import React from "react";
export default function DraggableSectionItem({
  boxColor,
  boxNumber,
  handleDrag,
  handleDrop,
  detail
}) {
  return (
    // <div
    //   draggable={true}
    //   id={boxNumber}
    //   onDragOver={(ev) => ev.preventDefault()}
    //   onDragStart={handleDrag}
    //   onDrop={handleDrop}
    //   style={{
    //     backgroundColor: boxColor,
    //     border: "1px solid",
    //     borderColor: boxColor,
    //     borderRadius: "5px",
    //     color: "#FFF",
    //     width: "250px",
    //     height: "90px",
    //   }}
    // >
    //   {boxNumber}

    // </div>
    <div
      draggable={true}
      id={boxNumber}
      onDragOver={(ev) => ev.preventDefault()}
      onDragStart={handleDrag}
      onDrop={handleDrop}
      className="MuiStep-root MuiStep-horizontal MuiStep-alternativeLabel pending   css-12mggvn-MuiStep-root"
      title=""
    >
      <span className="MuiStepLabel-root MuiStepLabel-horizontal MuiStepLabel-alternativeLabel css-z1gvki-MuiStepLabel-root">
        <span className="MuiStepLabel-iconContainer MuiStepLabel-alternativeLabel css-vnkopk-MuiStepLabel-iconContainer">
          <div className="css-j6pt0">
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              transform="scale(0.9)"
            >
              <g clip-path="url(#clip0_5154_15002)">
                <rect
                  x="0.857422"
                  width="24"
                  height="24"
                  rx="12"
                  fill="none"
                ></rect>
                <circle cx="12.8574" cy="12" r="4" fill="white"></circle>
              </g>
              <defs>
                <clipPath id="clip0_5154_15002">
                  <rect
                    x="0.857422"
                    width="24"
                    height="24"
                    rx="12"
                    fill="white"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </div>
        </span>
        <span className="MuiStepLabel-labelContainer MuiStepLabel-alternativeLabel css-1vyamtt-MuiStepLabel-labelContainer">
          <span className="MuiStepLabel-label MuiStepLabel-alternativeLabel css-b1ouky-MuiStepLabel-label">
            <div className="MuiBox-root css-155jd31">{detail?.text}</div>
            <div className="MuiBox-root css-1kle25g"></div>
          </span>
        </span>
      </span>
    </div>
  );
}
